import { render, staticRenderFns } from "./UsdtPayEnergyConfig.vue?vue&type=template&id=5044cdcf&scoped=true"
import script from "./UsdtPayEnergyConfig.vue?vue&type=script&lang=js"
export * from "./UsdtPayEnergyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5044cdcf",
  null
  
)

export default component.exports